import { Centrifuge, TransportEndpoint } from 'centrifuge';
import { createContext, memo, useContext, useEffect, useState } from 'react';
import { useUnMount } from '../hooks';
import { SOCKET_ENABLED, SOCKET_URL } from './constants';
import { useGetSocketToken } from './hooks/use-get-socket-token';
import {
  SocketContextData as ContextData,
  SocketProviderProps as ContextProps,
} from './types';

const context = createContext<ContextData>({} as ContextData);

const { Provider } = context;

export const SocketProvider = memo(
  ({ children, url = SOCKET_URL }: ContextProps) => {
    const socketTokenApi = useGetSocketToken();
    const [socket, setSocket] = useState<ContextData['socket']>();
    const isSecure = window.location.protocol.replace(':', '') === 'https';
    const websocketProtocol = isSecure ? 'wss' : 'ws';

    useEffect(() => {
      if (!SOCKET_ENABLED || !socketTokenApi.data?.token) return;

      const transports: TransportEndpoint[] = [
        {
          transport: 'websocket',
          endpoint: `${websocketProtocol}://${url}/websocket`,
        },
        {
          transport: 'http_stream',
          endpoint: `https://${url}/http_stream`,
        },
      ];

      const centrifuge = new Centrifuge(transports, {
        token: socketTokenApi.data?.token,
        // @ts-ignore
        emulationEndpoint: null,
      });

      centrifuge
        .on('connecting', function (ctx) {
          // console.log(`connecting: ${ctx.code}, ${ctx.reason}`);
        })
        .on('connected', function (ctx) {
          // console.log(`connected over ${ctx.transport}`);
        })
        .on('disconnected', function (ctx) {
          // console.log(`disconnected: ${ctx.code}, ${ctx.reason}`);
        })
        .on('error', function (ctx) {
          // console.log(`socket connection error: ${JSON.stringify(ctx)}`);
        })
        .connect();

      setSocket(centrifuge);
    }, [socketTokenApi.data?.token, url]);

    useUnMount(() => {
      socket?.disconnect();
    });

    return (
      <Provider
        value={{
          url,
          socket,
        }}
      >
        {children}
      </Provider>
    );
  }
);

export const useSocket = () => useContext(context).socket;
